(function () {
  class SupplementFilterGrid extends HTMLElement {
    constructor() {
      super();
      this.isClientDashboard = false;
      this.displayInModal = false;
      this.triggerSelector = '';
      this.modal = null;
      this.collectionTags = null;
      this.searchInput = null;
      this.loadingIcon = null;
      this.subscriptionEditing = '';
      this.itemCountDisplay = null;
      localStorage.removeItem('subscriptionMutations');
    }
    connectedCallback() {
      this.displayInModal = this.dataset['displayInModal'] === 'true';
      this.triggerSelector = this.dataset['modalTriggerSelector'] || '';
      this.isClientDashboard = this.dataset['isClientDashboard'] === 'true';
      this.modal = document.getElementById('supplementModal');
      this.searchInput = document.querySelector('#product-search');
      this.loadingIcon = document.getElementById('loading-icon');
      this.itemCountDisplay = this.isClientDashboard
        ? document.querySelector('.supplement-items')
        : null;
      this.addEventListeners();
    }
    addEventListeners() {
      const closeButton = document.querySelector('.modal-close');
      if (closeButton) {
        closeButton.addEventListener('click', this.closeModal.bind(this));
      }
      const modal = document.querySelector('#supplementModal');
      if (modal) {
        modal.addEventListener('click', (event) => {
          if (event.target === event.currentTarget) {
            this.closeModal();
          }
        });
      }
      if (this.displayInModal && this.triggerSelector) {
        const triggerElement = document.querySelector(this.triggerSelector);
        if (triggerElement) {
          triggerElement.addEventListener('click', this.openModal.bind(this));
        }
      }
      this.collectionTags = document.querySelector('#collection-tags');
      if (this.collectionTags) {
        this.collectionTags.addEventListener('click', this.handleCollectionTagClick.bind(this));
      }
      if (this.searchInput) {
        this.searchInput.addEventListener(
          'input',
          this.debounce(() => {
            this.toggleLoadingIndicator();
            this.filterProducts();
            this.toggleLoadingIndicator();
          }, 500)
        );
      }
      document.addEventListener('DOMContentLoaded', () => {
        const collectionLinks = document.querySelectorAll('.tag-link');
        setTimeout(() => {
          collectionLinks[0].click();
        }, 550);
      });
      const confirmButton = document.querySelector('.supplement-confirmation button');
      confirmButton?.addEventListener('click', this.commitSupplementAdditions.bind(this));
      const clearButton = document.querySelector('.button--clear');
      if (clearButton) {
        clearButton.addEventListener('click', this.clear);
      }
    }
    handleCollectionTagClick(event) {
      const target = event.target;
      if (!target || target.classList.contains('tag-link') === false) return;
      const attr = {
        selected: 'data-selected',
        tagActive: 'tag-active',
      };
      document.querySelectorAll('.tag-link').forEach((link) => {
        if (link !== target) {
          link.setAttribute(attr.selected, 'false');
          link.classList.remove(attr.tagActive);
        }
      });
      const isSelected = target.getAttribute(attr.selected) === 'true';
      target.setAttribute(attr.selected, (!isSelected).toString());
      if (!isSelected) {
        target.classList.add(attr.tagActive);
      } else {
        target.classList.remove(attr.tagActive);
      }
      this.fetchRenderedSections();
    }
    openModal() {
      if (this.modal) {
        this.modal.style.display = 'block';
      }
      this.clear();
    }
    closeModal(clearData = true) {
      if (this.modal) {
        this.modal.style.display = 'none';
        if (clearData === true) {
          localStorage.removeItem('subscriptionMutations');
          const confirmButton = document.querySelector('.supplement-confirmation');
          if (confirmButton) {
            confirmButton.classList.remove('supplement-confirmation--active');
          }
          document
            .querySelectorAll('.card-overlay--selected')
            .forEach((overlay) => overlay.remove());
          this.subscriptionEditing = '';
        }
      }
    }
    clear() {
      localStorage.removeItem('subscriptionMutations');
      document.querySelectorAll('.card-overlay--selected').forEach((overlay) => overlay.remove());
      const confirmButton = document.querySelector('.supplement-confirmation');
      if (confirmButton) {
        confirmButton.classList.remove('supplement-confirmation--active');
      }
    }
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
    filterProducts() {
      this.updateStatusMessage();
      const searchTerm = this.searchInput?.value.toLowerCase() || '';
      const products = document.querySelectorAll('#products-grid .grid__item');
      products.forEach((productEl) => {
        const productName =
          productEl.querySelector('.card__heading')?.innerText.toLowerCase() || '';
        if (productName.includes(searchTerm)) {
          productEl.style.display = 'block';
        } else {
          productEl.style.display = 'none';
        }
        if (productName.includes('your personalised stack')) {
          productEl.style.display = 'none';
        }
      });
    }
    fetchRenderedSections() {
      const selectedLinks = document.querySelectorAll('.tag-link[data-selected="true"]');
      const handles = Array.from(selectedLinks).map((link) => link.dataset.collectionHandle);
      const productsGrid = document.getElementById('products-grid');
      this.toggleLoadingIndicator();
      const promises = handles.map((handle) =>
        fetch(`/collections/${handle}`).then((response) => response.text())
      );
      Promise.all(promises)
        // eslint-disable-next-line sonarjs/cognitive-complexity
        .then((htmlStrings) => {
          const products = [];
          const seenIds = new Set();
          htmlStrings.forEach((htmlString) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlString, 'text/html');
            const content = doc.getElementById('ProductGridContainer');
            if (content) {
              content.querySelectorAll('.grid__item').forEach((productEl) => {
                if (this.isNMNProduct(productEl)) return;
                productEl.classList.remove('scroll-trigger');
                productEl.classList.remove('animate--slide-in');
                const productId = productEl.getAttribute('data-product-id');
                if (!seenIds.has(productId)) {
                  seenIds.add(productId);
                  if (this.isClientDashboard) {
                    productEl = this.convertProductCard(productEl);
                  }
                  products.push(productEl.outerHTML);
                }
              });
            }
          });
          if (productsGrid) {
            productsGrid.innerHTML = products.join(' ');
            this.updateStatusMessage();
            this.filterProducts();
            const productCards = document.querySelectorAll('#products-grid .grid__item');
            productCards.forEach((card) => {
              const button = card.querySelector('button');
              button?.addEventListener('click', this.addSupplementToStack.bind(this));
            });
            this.bindQuantityButtons();
            if (this.subscriptionEditing) {
              const supplements = this.getAddedSupplements();
              if (Object.keys(supplements).length > 0) {
                this.updateTotalItemCountDisplay(
                  supplements[this.subscriptionEditing].reduce(
                    (acc, supplement) => acc + supplement.quantity,
                    0
                  )
                );
              }
            }
          }
          this.toggleLoadingIndicator();
        })
        .catch((error) => {
          this.toggleLoadingIndicator();
          Bugsnag.notify(error);
          console.error('Error fetching rendered sections:', error);
        });
    }
    commitSupplementAdditions() {
      const customEvent = new CustomEvent('confirmAddSupplements');
      document.dispatchEvent(customEvent);
      this.closeModal(false);
    }
    convertProductCard(card) {
      const button = card.querySelector('button[type="submit"]');
      const buttonContainer = card.querySelector('.quick-add');
      if (!button || !buttonContainer) {
        console.error('button or product form not found');
        return card;
      }
      const links = card.querySelectorAll('a');
      links.forEach((link) => link.setAttribute('target', '_blank'));
      const handle = card.dataset['handle'] || '';
      const newButton = document.createElement('button');
      newButton.innerText = 'Add';
      newButton.dataset['handle'] = handle;
      if (this.subscriptionEditing) {
        const subscriptionMutations = this.getAddedSupplements();
        if (
          subscriptionMutations[this.subscriptionEditing] &&
          subscriptionMutations[this.subscriptionEditing].find((x) => x.handle === handle)
        ) {
          card = this.setCardToSelected(card, handle);
        }
      }
      newButton.classList.add(
        ...['button', 'button--full-width', 'button--secondary', 'no-variants']
      );
      buttonContainer.replaceWith(newButton);
      return card;
    }
    isNMNProduct(productEl) {
      const link = productEl.querySelector('a.full-unstyled-link');
      return (link?.textContent || '').toLowerCase().includes('nmn');
    }
    updateStatusMessage() {
      const searchTerm = this.searchInput?.value;
      const selectedLinks = document.querySelectorAll('.tag-link[data-selected="true"]');
      const categories = Array.from(selectedLinks)
        .map((link) => link.innerText)
        .join(', ');
      const statusMessage = document.getElementById('status-message');
      if (!statusMessage) return;
      if (searchTerm && categories) {
        statusMessage.innerText = `Searching for "${searchTerm}" in ${categories}`;
      } else if (searchTerm) {
        statusMessage.innerText = `Searching for "${searchTerm}"`;
      } else if (categories) {
        statusMessage.innerText = `Showing products in ${categories}`;
      } else {
        statusMessage.innerText = '';
      }
    }
    toggleLoadingIndicator() {
      if (this.loadingIcon === null || this.loadingIcon === undefined) return;
      this.loadingIcon.style.display =
        this.loadingIcon.style.display === 'none' || this.loadingIcon.style.display === ''
          ? 'block'
          : 'none';
    }
    setCardToSelected(card, handle) {
      const cardOverlay = document.createElement('div');
      cardOverlay.classList.add('card-overlay--selected');
      const supplements = this.getAddedSupplements();
      const manageSupplement = document.createElement('div');
      const quantityDisplay = document.createElement('div');
      const incrementInput = document.createElement('button');
      const decrementInput = document.createElement('button');
      manageSupplement.append(decrementInput, quantityDisplay, incrementInput);
      manageSupplement.classList.add('manage-supplement');
      incrementInput.dataset['handle'] = handle;
      decrementInput.dataset['handle'] = handle;
      quantityDisplay.innerText =
        supplements[this.subscriptionEditing]
          .find((x) => x.handle === handle)
          ?.quantity.toString() || '0';
      quantityDisplay.classList.add('quantity-display');
      incrementInput.innerText = '+';
      decrementInput.innerText = '-';
      incrementInput.classList.add('manage-supplement__increment');
      decrementInput.classList.add('manage-supplement__decrement');
      incrementInput.addEventListener('click', this.addSupplementToStack.bind(this));
      decrementInput.addEventListener('click', this.removeSupplementFromStack.bind(this));
      cardOverlay.append(manageSupplement);
      card.style.position = 'relative';
      card.append(cardOverlay);
      const confirmButton = document.querySelector('.supplement-confirmation');
      if (confirmButton) {
        confirmButton.classList.add('supplement-confirmation--active');
      }
      return card;
    }
    bindQuantityButtons() {
      document
        .querySelectorAll('.manage-supplement__decrement')
        .forEach((button) =>
          button.addEventListener('click', this.removeSupplementFromStack.bind(this))
        );
      document
        .querySelectorAll('.manage-supplement__increment')
        .forEach((button) =>
          button.addEventListener('click', this.addSupplementToStack.bind(this))
        );
    }
    addSupplementToStack(e) {
      const button = e.target;
      if (!button) return;
      const handle = button.dataset['handle'];
      if (!handle) return;
      const supplementQuantity = this.addSupplement(handle);
      if (supplementQuantity === 1) {
        const card = button.closest('.grid__item');
        if (card) {
          this.setCardToSelected(card, handle);
        }
      } else {
        this.updateSupplementItemCountDisplay(button, supplementQuantity);
      }
    }
    removeSupplementFromStack(e) {
      const button = e.target;
      const handle = button?.dataset['handle'];
      if (!button || !handle) throw new Error('SupplementFilterGrid: button or handle not found');
      const result = this.removeSupplement(handle);
      if (result.totalRemaining <= 0) {
        const confirmButton = document.querySelector('.supplement-confirmation');
        if (confirmButton) {
          confirmButton.classList.remove('supplement-confirmation--active');
        }
      }
      if (result.supplementQuantity === 0) {
        const card = button.closest('.grid__item');
        if (!card) return;
        const overlay = card.querySelector('.card-overlay--selected');
        if (overlay) overlay.remove();
      } else {
        this.updateSupplementItemCountDisplay(button, result.supplementQuantity);
      }
    }
    updateTotalItemCountDisplay(total) {
      if (!this.itemCountDisplay || !total) return;
      this.itemCountDisplay.innerText = `${total} added`;
    }
    updateSupplementItemCountDisplay(button, quantity) {
      if (!button || !quantity) return;
      const quantityDisplay = button
        .closest('.manage-supplement')
        ?.querySelector('.quantity-display');
      if (quantityDisplay) {
        quantityDisplay.innerText = quantity.toString();
      }
    }
    getAddedSupplements() {
      return JSON.parse(localStorage.getItem('subscriptionMutations') || '{}');
    }
    addSupplement(handle) {
      if (this.subscriptionEditing === '') throw new Error('subscription id not available');
      if (!handle) throw new Error('handle not provided');
      const supplements = this.getAddedSupplements();
      if (!supplements[this.subscriptionEditing]) supplements[this.subscriptionEditing] = [];
      const existingSupplement = supplements[this.subscriptionEditing].find(
        (supplement) => supplement.handle === handle
      );
      if (existingSupplement) {
        existingSupplement.quantity++;
      } else {
        supplements[this.subscriptionEditing].push({ handle, quantity: 1 });
      }
      localStorage.setItem('subscriptionMutations', JSON.stringify(supplements));
      this.updateTotalItemCountDisplay(
        supplements[this.subscriptionEditing].reduce(
          (acc, supplement) => acc + supplement.quantity,
          0
        )
      );
      return supplements[this.subscriptionEditing].reduce(
        (acc, supplement) => acc + (supplement.handle === handle ? supplement.quantity : 0),
        0
      );
    }
    removeSupplement(handle) {
      if (this.subscriptionEditing === '') throw new Error('subscription id not available');
      if (!handle) throw new Error('handle not provided');
      const supplements = this.getAddedSupplements();
      const existingSupplement = supplements[this.subscriptionEditing].find(
        (supplement) => supplement.handle === handle
      );
      if (existingSupplement) {
        existingSupplement.quantity--;
        if (existingSupplement.quantity <= 0) {
          supplements[this.subscriptionEditing] = supplements[this.subscriptionEditing].filter(
            (supplement) => supplement.handle !== handle
          );
        }
      }
      localStorage.setItem('subscriptionMutations', JSON.stringify(supplements));
      this.updateTotalItemCountDisplay(
        supplements[this.subscriptionEditing].reduce(
          (acc, supplement) => acc + supplement.quantity,
          0
        )
      );
      return {
        supplementQuantity: supplements[this.subscriptionEditing].reduce(
          (acc, supplement) => acc + (supplement.handle === handle ? supplement.quantity : 0),
          0
        ),
        totalRemaining: supplements[this.subscriptionEditing].length,
      };
    }
  }
  if (!customElements.get('supplement-filter-grid')) {
    customElements.define('supplement-filter-grid', SupplementFilterGrid);
  }
})();
